<template>
  <div class="rightSection" :style="customSearchDisplay">
    <slot name="quickFilter"></slot>
    <div class="searchBox fix-width__medium" :style="customInput">
      <i class="fas fa-search color__silver"></i>
      <el-input
        class="input-border__bottom input-border__radius__0"
        v-model="keyword_"
        size="medium"
        :placeholder="placeHolder ? placeHolder : 'Nhập từ khoá'"
        @keydown.enter.exact.native="$emit('simpleSearch', keyword_)"
      />
    </div>
    <el-tooltip
      content="Tìm kiếm nâng cao"
      placement="top"
      slot="reference"
      v-if="!isDisableAdvanceSearch"
    >
      <i
        class="fas fa-filter clickable color__blue"
        @click="$emit('search', keyword_)"
      ></i>
    </el-tooltip>
    <slot name="advance" v-if="!isDisableAdvanceSearch"></slot>
  </div>
</template>

<script>
export default {
  name: "search",
  props: [
    "keyword",
    "isDisableAdvanceSearch",
    "customStyle",
    "customSearchDisplay",
    "placeHolder",
    "customInput",
  ],
  data() {
    return {
      keyword_: "",
    };
  },
  created() {
    this.keyword_ = this.keyword;
    this.customStyle_ = this.customStyle;
  },
  watch: {
    keyword(newValue) {
      this.keyword_ = newValue;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/search.vue